// This file is auto-generated by @hey-api/openapi-ts

export const CardApplicationStatesEnum = {
    WAITING_TO_BE_PRINTED: 'WAITING_TO_BE_PRINTED',
    PROCESSED: 'PROCESSED',
    REJECTED: 'REJECTED',
    UNCHECKED_DATA: 'UNCHECKED_DATA'
} as const;

export type CardApplicationStatesEnum = typeof CardApplicationStatesEnum[keyof typeof CardApplicationStatesEnum];
